// @generated <<SignedSource::*O*zOeWoEQle#+L!plEphiEmie@IsG>>
import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('relay-migration-issue-fields-original-estimate');
	},
};
